import React from 'react';
import './StatCard.css';

const StatCard = ({ title, value, unit, icon, trend, className = '' }) => {
  return (
    <div className={`stat-card ${className}`}>
      <div className="stat-card-header">
        {icon && <span className="stat-icon">{icon}</span>}
        <h3 className="stat-title">{title}</h3>
      </div>
      <div className="stat-value-container">
        <span className="stat-value">{value}</span>
        {unit && <span className="stat-unit">{unit}</span>}
      </div>
      {trend && (
        <div className={`stat-trend ${trend.type}`}>
          {trend.icon && <span>{trend.icon}</span>}
          <span>{trend.text}</span>
        </div>
      )}
    </div>
  );
};

export default StatCard;

